export const HOLD_MUSIC_PRESET_IDS = ["calm", "classic", "lively"];
export const DEFAULT_HOLD_MUSIC_PRESET = "calm";
export const HOLD_MUSIC_MAX_BYTES = 5 * 1024 * 1024;
export const HOLD_MUSIC_ACCEPT = "audio/mpeg,audio/wav,audio/x-wav,audio/wave,.mp3,.wav";

/** MP3 públicos da Twilio (não usar twimlets: devolvem TwiML, não áudio). */
export const HOLD_MUSIC_PRESET_STREAMS = {
  calm: "https://s3.amazonaws.com/com.twilio.music.soft-rock/_ghost_-_promo_2_sample_pack.mp3",
  classic: "https://s3.amazonaws.com/com.twilio.music.classical/MARKOVICHAMP-Borghestral.mp3",
  lively: "https://s3.amazonaws.com/com.twilio.music.guitars/Pitx_-_Long_Winter.mp3",
};

export function parseHoldMusicSelection(raw) {
  const s = String(raw || "").trim();
  if (!s) return { kind: "preset", id: DEFAULT_HOLD_MUSIC_PRESET, url: "" };
  const presetMatch = s.match(/^preset:(calm|classic|lively)$/i);
  if (presetMatch) {
    return { kind: "preset", id: presetMatch[1].toLowerCase(), url: "" };
  }
  if (/^https:\/\//i.test(s)) {
    return { kind: "custom", id: null, url: s };
  }
  return { kind: "preset", id: DEFAULT_HOLD_MUSIC_PRESET, url: "" };
}

export function holdMusicValueFromSelection(kind, { presetId, customUrl } = {}) {
  if (kind === "custom") {
    const url = String(customUrl || "").trim();
    return /^https:\/\//i.test(url) ? url : "";
  }
  const id = HOLD_MUSIC_PRESET_IDS.includes(presetId)
    ? presetId
    : DEFAULT_HOLD_MUSIC_PRESET;
  return `preset:${id}`;
}

export function looksLikeMp3OrWav(bytes, filename = "") {
  const buf = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || []);
  const name = String(filename || "").toLowerCase();
  if (buf.length >= 3 && buf[0] === 0x49 && buf[1] === 0x44 && buf[2] === 0x33) {
    return true;
  }
  if (buf.length >= 2 && buf[0] === 0xff && (buf[1] & 0xe0) === 0xe0) {
    return true;
  }
  if (
    buf.length >= 12 &&
    buf[0] === 0x52 &&
    buf[1] === 0x49 &&
    buf[2] === 0x46 &&
    buf[3] === 0x46 &&
    buf[8] === 0x57 &&
    buf[9] === 0x41 &&
    buf[10] === 0x56 &&
    buf[11] === 0x45
  ) {
    return true;
  }
  if (name.endsWith(".mp3") && buf.length >= 2 && buf[0] === 0xff) return true;
  return false;
}

export async function validateHoldMusicFile(file) {
  if (!file) return { ok: false, reason: "missing" };
  const name = String(file.name || "").trim();
  const lower = name.toLowerCase();
  const type = String(file.type || "").trim().toLowerCase();
  const n = Number(file.size);
  if (!name) return { ok: false, reason: "missing" };
  if (!Number.isFinite(n) || n <= 0) return { ok: false, reason: "empty" };
  if (n > HOLD_MUSIC_MAX_BYTES) return { ok: false, reason: "too_large" };
  if (!lower.endsWith(".mp3") && !lower.endsWith(".wav")) {
    return { ok: false, reason: "format" };
  }
  if (
    type &&
    !/^audio\/(mpeg|mp3|wav|x-wav|wave)(;|$)/i.test(type) &&
    type !== "application/octet-stream"
  ) {
    return { ok: false, reason: "format" };
  }
  try {
    const head = new Uint8Array(await file.slice(0, 16).arrayBuffer());
    if (!looksLikeMp3OrWav(head, name)) return { ok: false, reason: "corrupt" };
  } catch {
    return { ok: false, reason: "corrupt" };
  }
  return { ok: true };
}

export function holdMusicFileErrorMessage(reason, t) {
  const key = {
    missing: "channelForm.twilioPhone.holdMusicErrMissing",
    empty: "channelForm.twilioPhone.holdMusicErrEmpty",
    too_large: "channelForm.twilioPhone.holdMusicErrTooLarge",
    format: "channelForm.twilioPhone.holdMusicErrFormat",
    corrupt: "channelForm.twilioPhone.holdMusicErrCorrupt",
  }[reason];
  const fallback = {
    missing: "Escolha um arquivo de áudio.",
    empty: "O arquivo está vazio.",
    too_large: "O arquivo passa de 5 MB. Envie um MP3 ou WAV mais curto.",
    format: "Use só MP3 ou WAV. M4A, OGG e outros a linha telefônica não toca.",
    corrupt: "Este arquivo não parece um áudio válido. Exporte de novo como MP3 ou WAV.",
  }[reason] || "Não foi possível usar este arquivo.";
  return typeof t === "function" ? t(key, fallback) : fallback;
}
